import { map } from "rxjs/operators";
export function indexElements(project = (value, index) => index) {
    return map(project);
}
//# sourceMappingURL=indexElements.js.map